import React, { JSX } from 'react'
import { observer } from 'mobx-react'
import SyncLoader from 'react-spinners/SyncLoader'
import BounceLoader from 'react-spinners/BounceLoader'

export const Spinner: React.FC<{
  isLoading?: boolean
  size?: number
  className?: string
}> = ({ isLoading = true, size = 15, className = '' }) => (
  <div
    className={`
      flex w-full justify-center py-4
      ${className}
    `}
  >
    <SyncLoader size={size} color="#2CD1A0" loading={isLoading}></SyncLoader>
  </div>
)

export const WaitForLoad: React.FC<{
  isLoading: boolean
  children: () => JSX.Element
  customSpinner?: JSX.Element
  className?: string
}> = observer(({ isLoading, children, customSpinner, className }) =>
  isLoading ? customSpinner || <Spinner className={className} /> : children()
)

export const LFBounceLoader: React.FC<{
  isLoading?: boolean
  size?: number
  className?: string
}> = ({ isLoading = true, size = 24, className = '' }) => (
  <div
    className={`
      flex items-center justify-center
      ${className}
    `}
  >
    <BounceLoader
      size={size}
      color="#2CD1A0"
      loading={isLoading}
    ></BounceLoader>
  </div>
)
